import { PageResponseVm } from 'api/core/page-response.vm';
import { IsString, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';
import { AreaVm } from './area.vm';

export class GetAreasVm extends PageResponseVm<AreaVm, string> {
  @IsString()
  nextOffset: string | null;

  @ValidateNested({ each: true })
  @Type(() => AreaVm)
  objects: AreaVm[];
}
